import { Input, Label } from 'shared-ui';

interface DownloadFileNameFieldProps {
    /** Input id; the error message uses `${id}-error`. */
    id: string;
    value: string;
    /** Validation error to show below the input, or null when valid. */
    error: string | null;
    onChange: (value: string) => void;
    /** Placeholder shown when the field is empty (e.g. an example name). */
    placeholder?: string;
}

/** Shared "Filename" field for the download panels (label + input + validation error). */
export function DownloadFileNameField({ id, value, error, onChange, placeholder }: DownloadFileNameFieldProps) {
    const errorId = `${id}-error`;
    return (
        <div className="space-y-1.5">
            <Label htmlFor={id} className="text-foreground text-sm leading-5 font-medium">
                Filename
            </Label>
            <Input
                id={id}
                value={value}
                placeholder={placeholder}
                onChange={(e) => {
                    onChange(e.target.value);
                }}
                aria-invalid={error != null}
                aria-describedby={error ? errorId : undefined}
                className="placeholder:text-sidebar-ring h-10 placeholder:text-sm placeholder:leading-5 placeholder:font-normal placeholder:tracking-normal placeholder:italic"
            />
            {error && (
                <p id={errorId} className="text-destructive text-xs">
                    {error}
                </p>
            )}
        </div>
    );
}
